export default __webpack_public_path__ + "static/media/android.01ffa905.svg";